import ComposeMail from "../../../mixins/compose-mail";
import ArchivingMixin from "../../../mixins/archiving-mixin";
import AddressMixin from "../../../mixins/address";

Vue.component("view-asset-group", {

    mixins: [AddressMixin, ComposeMail, ArchivingMixin],

    props: ["assetGroup", "groupTypes"],

    data () {
        return {
            mutableAssetGroup: this.assetGroup,
            documentsListUrl: "/assets/groups/" + this.assetGroup.id + "/documents",
            documentUploadUrl: "/assets/groups/" + this.assetGroup.id + "/documents/upload",
            showBulkAssetActions: false,
        };
    },

    computed: {
        contactsUrl () {
            return "/contacts/asset-groups/" + this.assetGroup.id;
        },
    },

    mounted () {
        let self = this;

        Bus.$on("asset-group-updated", function (assetGroup) {
            self.mutableAssetGroup = assetGroup;
        });
    },

    methods: {
        shareDocument (document) {
            this.createEmail(null, document.id, null);
        },

        addressUpdated (address) {
            this.mutableAssetGroup.address = address;
        },

        afterArchiving (archiving) {
            if (archiving) {
                this.mutableAssetGroup.archived_at = this.$dayjs().format();
                this.$refs.assetGroupAssets.fetchAssets();
            } else {
                this.mutableAssetGroup.archived_at = null;
            }
        },

        toggleBulkAssetsActions (tabName = null) {
            this.showBulkAssetActions = tabName !== null && tabName === "assets";
        },

        updatePortfolio () {
            let portfolios = [];
            this.app.state.user.portfolios.forEach((p) => {
                portfolios[p.id] = p.name;
            });

            let self = this;
            swal({
                title: "Change Portfolio for all assets",
                text: "Select the portfolio to move the assets to.",
                input: "select",
                inputOptions: portfolios,
                showCancelButton: true,
                inputValidator: (value) => {
                    return !value && "Select a portfolio";
                }
            }).then((result) => {
                if (result.value) {
                    self.moveSelectedAssetsToPortfolio(result.value);
                }
            });
        },

        moveSelectedAssetsToPortfolio (portfolioId) {
            App.post("/assets/bulk/portfolios/update", new AppForm({
                asset_group_id: this.assetGroup.id,
                portfolio_id: portfolioId
            })).then(response => {
                toastr.success(response);
            })
            .catch(error => {
                toastr.error(error.message);
            });
        },
    },
});
